var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CChartBar',{attrs:{"datasets":_vm.defaultDatasets,"options":_vm.defaultOptions,"labels":_vm.dataAverages.names}})}
var staticRenderFns = []

export { render, staticRenderFns }